import Redactor from '../../redactor.esm.min.js'
import { computedStyle, registerToolbarButton, setToolbarButtonHtml } from '../registerButton'
import { applyTextStyle } from '../textStyle'

class MpFontSizePlugin {
    static defaultOptions = {
        input: true
    }

    static defaultLang = {
        en: {
            mpFontSize: {
                title: 'Font Size'
            }
        }
    }

    constructor(app, options = {}) {
        this.app = app
        this.options = options
        this.fontSizes = [
            4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
            32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58,
            59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85,
            86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100
        ]
        this.currentlySelectedFontSize = ''
        this.defaultTitle = 'Size'
        this.buttonDropDownIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                <path d="M4.5 6L8.5 10L12.5 6" stroke="#9B9FA6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`
        this._onSelectionChange = () => {
            setTimeout(() => this._updateButtonContent(), 10)
        }
    }

    start() {
        registerToolbarButton(this.app, 'mpFontSize', this._createToolbarButton())
        this.app.on('click', this._onSelectionChange)
        this.app.on('key:up', this._onSelectionChange)
        this.app.on('editor:focus', this._onSelectionChange)
    }

    stop() {
        this.app.off('click', this._onSelectionChange)
        this.app.off('key:up', this._onSelectionChange)
        this.app.off('editor:focus', this._onSelectionChange)
    }

    _createToolbarButton() {
        return {
            title: 'Font Size',
            color: false,
            html: `<div>${this.defaultTitle}</div>
            ${this.buttonDropDownIcon}
            `,
            classname: 'mp-redactor-toolbar-plugin mp-font-size-button',
            position: { before: 'moreinline' },
            command: 'mpFontSize.popup'
        }
    }

    _updateButtonContent() {
        const selection = this.app.getService('selection')
        const inlines = selection.getNodes({ types: 'inline' }) || []
        let selectedFontSize = this.defaultTitle
        if (inlines.length) {
            const fontSizeValue = computedStyle(inlines[inlines.length - 1], 'font-size')
            if (fontSizeValue) {
                const numericValue = parseInt(fontSizeValue, 10)
                selectedFontSize = isNaN(numericValue) ? this.defaultTitle : numericValue.toString()
                this.currentlySelectedFontSize = numericValue
            } else {
                this.currentlySelectedFontSize = ''
            }
        } else {
            this.currentlySelectedFontSize = ''
        }

        const displayValue =
            typeof selectedFontSize === 'string' && selectedFontSize !== this.defaultTitle
                ? selectedFontSize.replace('px', '')
                : selectedFontSize
        setToolbarButtonHtml(this.app, 'mpFontSize', `<div>${displayValue}</div>${this.buttonDropDownIcon}`)
    }

    popup(_params, { button, el } = {}) {
        this.app.saveSelection()

        const items = this.fontSizes.map((fontSize) => ({
            title: '<div>' + fontSize + '</div>',
            command: 'mpFontSize.set',
            active: fontSize == this.currentlySelectedFontSize,
            params: {
                tag: 'span',
                style: {
                    'font-size': fontSize + 'px'
                }
            }
        }))
        this.app.dropdown.create('mpFontSize', { items: items })
        this.app.dropdown.open(button || el)
    }

    set(params = {}) {
        this.app.dropdown.close()
        const styles = params.styles || params.style
        applyTextStyle(this.app, styles)
    }
}

Redactor.addPlugin('mpFontSize', MpFontSizePlugin)
